import { Dispatch, SetStateAction, useEffect, useState } from "react";
import ImageX from "components/utility/images/ImageX";
import ContentPageShareLite from "./ContentPageShareLite";
import ContentPageShare from "./ContentPageShare";
import { DDXModal } from "components/ddx-modal/DDXModal";
import { SearchPageActionsShareProps } from "components/search/client/SearchPageActions";

interface ContentPageActionsShareModalProps {
	isOpen: boolean;
	setOpenFlag: Dispatch<SetStateAction<boolean>>;
	data: SearchPageActionsShareProps;
	modalClick: (flag: boolean) => void;
	isCopied?: (flag: boolean) => void;
	analytics: object;
}

const ContentPageActionsShareModal = ({
	isOpen,
	setOpenFlag,
	data,
	analytics,
	modalClick,
	isCopied: isCopiedProps
}: React.PropsWithChildren<ContentPageActionsShareModalProps>) => {
	const [isCopied, setIsCopied] = useState<boolean>(false);
	const [shareExplanationFlag, setShareExplanationFlag] = useState<boolean>(false);
	const [mobileTooltipInitFlag, setIsMobileTooltipInitFlag] = useState<boolean>(false);

	useEffect(() => {
		if (!mobileTooltipInitFlag && shareExplanationFlag) {
			setIsMobileTooltipInitFlag(true);
		}
	}, [mobileTooltipInitFlag, shareExplanationFlag]);

	const closeModal = () => {
		setOpenFlag(false);
	};

	const setCopyFlag = (flag) => {
		setIsCopied(flag);
		modalClick(true);
		if (isCopiedProps) {
			isCopiedProps(flag);
		}
	};

	const { isNormalShare, theme } = data;

	return (
		<DDXModal
			showModal={isOpen}
			handleCloseModal={closeModal}
			className="content-page-share-modal-overlay"
		>
			<div
				className={
					`content-page-share${isNormalShare ? "" : "-lite"}-modal ${theme ? theme : ""} ${
						isCopied ? "copied" : ""
					}` +
					` ${
						isNormalShare
							? mobileTooltipInitFlag
								? "content-page-share-mobile-animation"
								: "content-page-share-mobile-animation-no-delay"
							: ""
					}` +
					` ${shareExplanationFlag ? "content-page-share-mobile-animation-bottom" : ""}`
				}
			>
				<div>
					<button
						className="content-page-share-modal-close"
						onClick={closeModal}
						aria-label="close"
						data-qa="share-modal-close"
					>
						<ImageX />
					</button>
				</div>
				{isNormalShare ? (
					<ContentPageShare
						{...data}
						setCopyFlag={setCopyFlag}
						setShareExplanationFlag={setShareExplanationFlag}
						mobileTooltipInitFlag={mobileTooltipInitFlag}
						analytics={analytics}
					/>
				) : (
					<ContentPageShareLite {...data} setCopyFlag={setCopyFlag} />
				)}
			</div>
		</DDXModal>
	);
};

export default ContentPageActionsShareModal;
